import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const NONE = '__none__';

export const ChatterMappingTable = ({ refreshKey, onChange }) => {
  const [data, setData] = useState({ chatters: [], vas: [] });

  const load = useCallback(() => axios.get(`${API_URL}/chatting/chatters`).then(r => setData(r.data))
    .catch(() => toast.error('Failed to load chatters')), []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const setMapping = async (uuid, value) => {
    try {
      await axios.put(`${API_URL}/chatting/chatters/${uuid}/mapping`, { va_id: value === NONE ? null : value });
      toast.success('Chatter linked');
      onChange?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to link chatter');
    }
  };

  const vas = [...data.vas].sort((a, b) => (a.role?.includes('Chatting') ? -1 : 1) - (b.role?.includes('Chatting') ? -1 : 1));
  return (
    <div className="bg-card rounded-md border border-border" data-testid="chatter-mapping-table">
      <div className="p-4 border-b border-zinc-800">
        <div className="text-white font-semibold">Fanvue team → VAs</div>
        <div className="text-xs text-zinc-500">Linked automatically when the Fanvue email matches the VA email. Change it here if needed.</div>
      </div>
      {data.chatters.length === 0 ? (
        <div className="p-4 text-sm text-zinc-500" data-testid="chatter-mapping-empty">No Fanvue team members yet. Connect Fanvue first.</div>
      ) : data.chatters.map(c => (
        <div key={c.chatter_uuid} className="flex flex-wrap items-center justify-between gap-3 p-3 border-b border-zinc-800 last:border-0">
          <div>
            <div className="text-white text-sm">{c.name}{c.is_admin && <span className="ml-2 text-xs text-zinc-500">admin</span>}</div>
            <div className="text-xs text-zinc-500">{c.email}{c.va_id && !c.manual && ' · auto-linked'}</div>
          </div>
          <Select value={c.va_id || NONE} onValueChange={v => setMapping(c.chatter_uuid, v)}>
            <SelectTrigger className="w-64 bg-zinc-900/50 border-zinc-800 text-white" data-testid={`chatter-map-select-${c.chatter_uuid}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-zinc-900 border-zinc-800 text-white">
              <SelectItem value={NONE}>Not linked</SelectItem>
              {vas.map(v => <SelectItem key={v.va_id} value={v.va_id}>{v.name} · {v.role}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
};
